import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, X, Phone } from "lucide-react";
import { api } from "../lib/api";

export default function NearestArea() {
  const [data, setData] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Only greet RETURNING visitors, and respect a dismissal.
    const visited = localStorage.getItem("c2c_visited");
    localStorage.setItem("c2c_visited", "1");
    if (!visited) return;
    if (localStorage.getItem("c2c_nearest_dismissed") === "1") return;

    api.get("/nearest-suburb")
      .then((r) => {
        if (r.data?.resolved && r.data?.in_area) { setData(r.data); setShow(true); }
      })
      .catch(() => {});
  }, []);

  if (!show || !data) return null;
  const dismiss = () => { localStorage.setItem("c2c_nearest_dismissed", "1"); setShow(false); };

  return (
    <div className="bg-brand-green text-white" data-testid="nearest-area-bar">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-2.5 flex items-center justify-center gap-3 text-sm">
        <MapPin className="h-4 w-4 shrink-0 text-brand-navy" />
        <p className="font-semibold text-center">
          Good news — we buy cars in your area.{" "}
          <Link to={`/areas/${data.slug}`} className="underline underline-offset-2 font-extrabold hover:text-brand-navy transition-colors" data-testid="nearest-area-link">
            Sell your car in {data.name} →
          </Link>
        </p>
        <a href="tel:0431206206" className="hidden sm:inline-flex items-center gap-1 font-bold hover:text-brand-navy transition-colors" data-testid="nearest-area-call">
          <Phone className="h-3.5 w-3.5" /> 0431 206 206
        </a>
        <button onClick={dismiss} aria-label="Dismiss" className="ml-1 shrink-0 opacity-80 hover:opacity-100" data-testid="nearest-area-dismiss">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
